module.exports = __webpack_public_path__ + "static/media/worry-michelin.8ce1406e.png";